import { Phone, MessageCircle } from "lucide-react";
import { motion } from "framer-motion";
import { SITE } from "@/lib/site";

export default function FloatingButtons() {
  const waMsg = encodeURIComponent("Hello Axomind, I'd like to schedule an investment consultation.");
  return (
    <div className="fixed bottom-6 right-6 z-40 flex flex-col gap-3 items-end" data-testid="floating-buttons">
      <motion.a
        href={`https://wa.me/${SITE.phoneRaw}?text=${waMsg}`}
        target="_blank"
        rel="noreferrer"
        data-testid="whatsapp-floating-button"
        aria-label="Chat on WhatsApp"
        initial={{ opacity: 0, scale: 0 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.5, type: "spring", stiffness: 200 }}
        className="group relative w-14 h-14 rounded-full bg-[#25D366] flex items-center justify-center shadow-[0_10px_40px_-5px_rgba(37,211,102,0.5)] hover:scale-110 transition-transform"
      >
        <MessageCircle size={24} className="text-white fill-white" />
        <span className="absolute right-full mr-3 px-3 py-1.5 rounded-lg bg-black/90 text-white text-xs whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
          Chat on WhatsApp
        </span>
        <span className="absolute inset-0 rounded-full pulse-gold" />
      </motion.a>

      <motion.a
        href={`tel:${SITE.phoneRaw}`}
        data-testid="call-floating-button"
        aria-label="Call now"
        initial={{ opacity: 0, scale: 0 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.7, type: "spring", stiffness: 200 }}
        className="group relative w-14 h-14 rounded-full bg-[#D4AF37] flex items-center justify-center shadow-[0_10px_40px_-5px_rgba(212,175,55,0.55)] hover:scale-110 transition-transform"
      >
        <Phone size={22} className="text-black" />
        <span className="absolute right-full mr-3 px-3 py-1.5 rounded-lg bg-black/90 text-white text-xs whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
          Call now
        </span>
      </motion.a>
    </div>
  );
}
